module.exports = __webpack_public_path__ + "static/media/pro_badge.afc43876.svg";